// extracted by mini-css-extract-plugin
export default {"pagination":"pagination___PVG4N","icon":"icon___rvXI4"};